// src/ui/features/calculator/components/CalculatorTopBar.jsx
import React from "react";
import { CrownIcon } from "../../primatives/Icons";

export default function CalculatorTopBar({
  onBack,
  mode = "degree", // "degree" | "module"
  onToggleMode,
  isPro,
  onRequestPro,
}) {
  const isModule = mode === "module";

  const onClickModule = () => {
    if (!isPro) {
      onRequestPro?.();
      return;
    }
    onToggleMode("module");
  };

  return (
    <div className="flex items-center justify-between gap-3">
      <button
        type="button"
        onClick={onBack}
        className="
          inline-flex items-center gap-2 rounded-xl border border-neutral-200
          bg-white px-3 py-2 text-sm font-medium text-neutral-800 hover:bg-neutral-100
          dark:border-neutral-800 dark:bg-neutral-900 dark:text-neutral-200 dark:hover:bg-neutral-800
          shrink-0
        "
      >
        ← Back to selection
      </button>

      {/* Mode switch */}
      <div
        className="
          inline-flex items-center gap-1 rounded-2xl border border-neutral-200 bg-white p-1
          dark:border-neutral-800 dark:bg-neutral-900
          ml-auto
        "
        role="tablist"
        aria-label="Calculator mode"
      >
        <button
          type="button"
          onClick={() => onToggleMode("degree")}
          className={
            !isModule
              ? "rounded-xl px-2.5 py-2 text-sm font-semibold bg-blue-600 text-white"
              : "rounded-xl px-2.5 py-2 text-sm font-semibold text-neutral-700 hover:bg-neutral-100 dark:text-neutral-200 dark:hover:bg-neutral-800"
          }
          role="tab"
          aria-selected={!isModule}
        >
          Degree
        </button>

        <button
          type="button"
          onClick={onClickModule}
          className={
            isModule
              ? "relative rounded-xl px-2.5 py-2 text-sm font-semibold bg-orange-500 text-white hover:bg-orange-600"
              : "relative rounded-xl px-2.5 py-2 text-sm font-semibold text-neutral-700 hover:bg-neutral-100 dark:text-neutral-200 dark:hover:bg-neutral-800"
          }
          role="tab"
          aria-selected={isModule}
        >
          Module

          {!isPro ? (
            <span
              className="
                ml-1 inline-flex items-center gap-1 rounded-full
                bg-orange-500/15 px-1.5 py-0.5 text-[10px] font-semibold text-orange-600
                ring-1 ring-orange-500/30
                dark:text-orange-300
              "
            >
              <CrownIcon className="h-3 w-3" />
              Pro
            </span>
          ) : null}
        </button>
      </div>
    </div>
  );
}
